<template>
  <div class="PaymentFaq">
    <el-card class="box-card">
      <h4 class="heading text-center">FREQUENTLY ASKED QUESTIONS</h4>
      <div class="sub-menu-bar-wrapper">
        <div
          class="sub-menu-bar-link cursor-pointer"
          @click="setActiveSubMenuLink('SUBSCRIPTION')"
          :class="{ 'active-sub-menu-link': activeFaqMenu == 'SUBSCRIPTION' }"
        >
          Subscription
        </div>
        <div
          class="sub-menu-bar-link cursor-pointer"
          @click="setActiveSubMenuLink('BILLING')"
          :class="{ 'active-sub-menu-link': activeFaqMenu == 'BILLING' }"
        >
          Billing
        </div>
        <div
          class="sub-menu-bar-link cursor-pointer"
          @click="setActiveSubMenuLink('PAYMENTS')"
          :class="{ 'active-sub-menu-link': activeFaqMenu == 'PAYMENTS' }"
        >
          Payments
        </div>
      </div>

      <div class="faq-container">
        <div v-if="activeFaqMenu == 'SUBSCRIPTION'">
          <ul>
            <li>
              <b>What subscription options do I have?</b> <br />

              Check StockAnts
              <u
                class="external-link-color cursor-pointer"
                @click="$router.push({ path: '/pricing' })"
                >Plans.</u
              ><br />

              Reach us on
              <span class="external-link-color cursor-pointer"
                >admin@stockants.com</span
              >
              for your requirements
            </li>
            <li>
              <b>Where can I cancel my subscription plan?</b> <br />

              You can cancel your subscribed plan anytime <br />

              Go to M Account/Membership. You can even email us at
              <span class="external-link-color cursor-pointer"
                >admin@stockants.com</span
              >
              <br />
            </li>
            <li>
              <b>From where can I change my plans?</b> <br />

              Go to My account/Membership <br />

              Email us at
              <span class="external-link-color cursor-pointer"
                >admin@stockants.com</span
              >
            </li>
            <!-- <li>
                            <b>Where can I check my data download status?</b> <br>

                            Go to My account/My downloads
                        </li> -->
            <li>
              <b>Where can I ask for support for my Account related details?</b>
              <br />

              You can reach us by raising ticket in Support <br />

              You can even email us directly at
              <span class="external-link-color cursor-pointer"
                >admin@stockants.com</span
              >
            </li>
          </ul>
        </div>

        <div v-if="activeFaqMenu == 'BILLING'">
          <ul>
            <li>
              <b>What options do I have for billing StockAnts Plans?</b> <br />

              StockAnts bills subscribed users on monthly basis only. If user is
              purchasing data from StockAnts platform in CVS format, then user
              will have to pay instantly for the data.
            </li>
            <li>
              <b>Where can I get my Invoices?</b> <br />

              StockAnts will email you Invoice for bills raised and payment
              done. <br />

              You can download Invoices from
              <u
                class="external-link-color cursor-pointer"
                @click="goToLink('Biling and Payments')"
                >My Account/Transaction History</u
              >
            </li>
            <li>
              <b>Where can I change my Billing details for tax benefit?</b>
              <br />

              You can add billing details in
              <u
                class="external-link-color cursor-pointer"
                @click="goToLink('Biling and Payments')"
                >My Account/ Billing details</u
              >
            </li>
            <li>
              <b>Where can I change my Payment details?</b> <br />

              You can change connected payment instrument for auto debit in
              <u
                class="external-link-color cursor-pointer"
                @click="goToLink('Membership')"
                >My Account/Payment details</u
              >
            </li>
          </ul>
        </div>

        <div v-if="activeFaqMenu == 'PAYMENTS'">
          <ul>
            <li>
              <b>What is the mode of payment StockAnts accepts?</b> <br />

              We accept all major credit and debit cards. We also accept
              payments by Internet banking, UPI and Wallets.
            </li>
            <li>
              <b>Do StockAnts have EMI facility?</b> <br />

              We don’t have EMI payments
            </li>
            <li>
              <b
                >Will My card details/payment details be saved with
                StockAnts?</b
              >
              <br />

              We have integrated third party payment gateway service with
              RAZORPAY. <br />
              It is the most tested and reliable payment gateway service. <br />
              All payment information of user will be saved with RAZORPAY.
              <br />
              <br />

              <b>Disclaimer-</b> StockAnts is not liable for any discrepancies
            </li>
            <li>
              <b>Where are get more details of payment gateway?</b> <br />

              Check out
              <a
                href="https://razorpay.com/privacy/"
                class="external-link-color cursor-pointer"
                >https://razorpay.com/privacy/</a
              >
            </li>
            <li>
              <b
                >Does plan price/ data price inclusive of Taxes and service
                charges?</b
              >
              <br />

              StockAnts plans /data prices are inclusive of all taxes and
              service charges
            </li>
            <li>
              <b>Unable to do payments?</b> <br />

              You can use different mode of payments <br />
              You can raise support ticket <br />
              Email us at
              <span class="external-link-color cursor-pointer"
                >admin@stockants.com</span
              >
            </li>
            <li>
              <b>Where can I apply for refund?</b> <br />

              StockAnts allows to cancel your subscription anytime <br />
              Sorry we do not give refunds <br />
            </li>
            <li>
              <b>How will I Know my payment is done?</b> <br />

              You will get email from StockAnts <br />
              Check your payment status in
              <u
                class="external-link-color cursor-pointer"
                @click="goToLink('Biling and Payments')"
                >My account/Transaction History</u
              >
            </li>
            <li>
              <b
                >Can I do partial payment or select multiple mode of
                payments?</b
              >
              <br />

              StockAnts does not accept partial payment or connecting multiple
              modes of payment <br />
            </li>
          </ul>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "PaymentFaq",
  data() {
    return {
     
    };
  },

  methods: {
    setActiveSubMenuLink(type) {
      if (type == "SUBSCRIPTION") {
        this.$store.commit("commitActivePaymentFAQMenu", "SUBSCRIPTION");
      } else if (type == "BILLING") {
        this.$store.commit("commitActivePaymentFAQMenu", "BILLING");
      } else {
        this.$store.commit("commitActivePaymentFAQMenu", "PAYMENTS");
      }
    },

    goToLink(params) {
      if (params) {
        this.$store.commit("commitMyAccountActiveState", params);

        // on link select scroll page to top
        var elmnt = document.getElementsByClassName("MyAccount")[0];
        scrollTo(elmnt, 0, 100);
      }
    },
  },

  computed: {
    activeFaqMenu() {
      return this.$store.state.active_payment_faq_menu;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
.PaymentFaq {
  .faq-container {
    padding: 0 15px;
    ul {
      padding: 0;
      font-size: 13px;
      font-weight: 500;
      color: #878684;
      text-align: justify;
    }
    ul li {
      margin: 10px 0;
    }
  }
  .sub-menu-bar-wrapper {
    justify-content: center;
  }
  .sub-menu-bar-link {
    margin: 0 20px 0 0px;
  }
  .heading-FAQ {
    padding: 45px 0 10px 0;
    letter-spacing: 3px;
    margin: 0;
  }
}
</style>
